import React, { PureComponent } from 'react'
import ProductItems from '../../../catalog/ProductItems'

class CatalogItems extends PureComponent {
  render () {
    return (
      <div style={{width:"90%", margin:"auto"}}>
        <ProductItems items={this.props.catalog_items || []} />
      </div>
    )
  }
}

export default CatalogItems



// WEBPACK FOOTER //
// ./src/components/e-commerce/catalog/components/CatalogItems.js